import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import EventsScreen from './events';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import Pollo from './pollo';
import LunchSpecial from './lunchspecial';

import QRCode from "react-qr-code";

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
     const [showModal, setShowModal] = React.useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [desserts, setdesserts] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showLunchSpecial, setShowLunchSpecial] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [pastapecado, setpastapecado] = useState(false);
    const [cocinacolombiana, setcocinacolombiana] = useState(false);
    const [fuertes, setfuertes] = useState(false);
    const [polloasado, setpolloasado] = useState(false);
    const [entradas, setentradas] = useState(false);
    const [antojitos, setantojitos] = useState(false);
    const [drinks, setdrinks] = useState(false);
    
        const [showPollo, setshowPollo] = useState(false);
    
   

    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };




         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 985) {
                setdesserts(item);
            }
            if (item.id === 628) {
                setBeverages(item);
            }

            if (item.id === 911) {
                setpastapecado(item)
            }
             if (item.id === 912) {
                setcocinacolombiana(item)
             }
            
            if (item.id === 909) {
                setfuertes(item)
            }
            if (item.id === 910) {
                setpolloasado(item)
            }

            if (item.id === 908) {
                setentradas(item)
            }
            if (item.id === 913) {
                setantojitos(item)
            }

            if (item.id === 915) {
                setdrinks(item)
            }

            
        });
    }, [menus]);


    const GoBeverages = () => {
        setShowListProduct(true);
        setdishs(Beverages);
    }


    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
          
          
           setShowLunchSpecial(false)
          
            setshowCategories(false)
            setShowDetailProduct(false)
            setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
          
           
           setShowLunchSpecial(false)
          
            setshowCategories(false)
          setShowDetailProduct(false)
           setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)
         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
                setShowDrinks(true)
        }} showBack={false} showCocktails={ GoBeverages} showEvents={ setShowEvents} showImageTop={true} setShowSpecials={setShowSpecials}>
                <div>
                    

                    <div style={{ width: '100%', position: 'relative', zIndex: 900, marginTop: -20, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{
                            position: 'absolute',
                            left:22,top: 27,
                           padding: 5, display: "flex", gap: 10, borderRadius: 14
                        }}>

                            <div onClick={()=>setShowModal('https://www.instagram.com/arubakikoriko/?hl=es')}>
<img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 40,
                            height: 40,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            marginBottom: 10
                                
                            
                            
                            
                        }}
                        src={require('./assets/instagram.png')}
                            />
                            </div>
                            
                            <div onClick={()=>setShowModal('https://www.facebook.com/Kikorikoarubaoficial/?locale=es_LA')}>
                                <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 40,
                            height: 40,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            marginBottom: 10
                                
                            
                            
                            
                        }}
                        src={require('./assets/facebook.png')}
                        />
                            </div>
                        </div>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 300,
                            height: 100,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            marginBottom: 10
                                
                            
                            
                            
                        }}
                        src={require('./assets/logo.png')}
                        />

                        
                       
                    </div>

                     <div
                    onClick={() => {
                       // setShowListProduct(true)
                        //setdishs(desserts)
                        //  setShowDetailProduct(true)
                 //   setDataDish({ dish: tomahawk, alldish: steak, currentDish: tomahawk })
               }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                
                    boxSizing: 'border-box',
                   
                    }}>
                    <video
                        loop autoPlay={true} muted 
                        onContextMenu={(e) => e.preventDefault()}
                        //src={require('./assets/bannerinferior.png')}
                        src={require('./assets/bannerh2.mp4')}
                            style={{
                        marginTop: 10,
                        width: '95%',
                        height: 180,
                        objectFit: 'contain',
                        borderRadius: 15,
                         pointerEvents: 'none',
                        
                    }}
                    />
                  
            </div>
                    
                    <div style={{
                     display: 'flex', width: '100%',
                        position: 'relative', zIndex: 100, paddingInline: 20,
                        boxSizing: 'border-box',
                        gap: 10,
                       
                    }}>
                       
                        
                    <div style={{ width: '60%', marginTop: 10}}>
                            <video
                           
                            src={require('./assets/banner1.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                               
                                width: '100%',
                                height: 325,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                               
                            }}
                            />

                            <video
                           
                            src={require('./assets/banner22.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                               
                                width: '100%',
                                height: 212,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                               
                            }}
                            />
                            
                           

                    </div>

                    <div style={{ width: '40%', marginTop: 5 }} >
                          
                        <div
                            style={{
                                display: 'grid',
                                height: 540,
                                overflowY: 'auto',
                                paddingRight: 0,
                                boxSizing: 'border-box',
                                marginTop: 5,
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 62,
                                    position: 'relative',
                                        cursor: 'pointer',
                                    backgroundImage: `url(${require(langEng ? './assets/categorias/en/1.png' : './assets/categorias/1.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                   setShowListProduct(true);
                                     setdishs(pastapecado);
                                  //  console.log({pastapecado})
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                            </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 62,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require(langEng ? './assets/categorias/en/2.png' : './assets/categorias/2.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                   setShowListProduct(true);
                                         setdishs(cocinacolombiana);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 62,
                                    position: 'relative',
                                    cursor: 'pointer',
                                     backgroundImage: `url(${require(langEng ? './assets/categorias/en/3.png' : './assets/categorias/3.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                     setShowListProduct(true);
                                         setdishs(fuertes);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 62,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require(langEng ? './assets/categorias/en/4.png' : './assets/categorias/4.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setshowPollo(true)
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 62,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require(langEng ? './assets/categorias/en/5.png' : './assets/categorias/5.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                     setShowListProduct(true);
                                         setdishs(entradas);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 62,
                                    position: 'relative',
                                    cursor: 'pointer',
                                    backgroundImage: `url(${require(langEng ? './assets/categorias/en/6.png' : './assets/categorias/6.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setShowListProduct(true);
                                         setdishs(antojitos);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 62,
                                    position: 'relative',
                                    cursor: 'pointer',
                                     backgroundImage: `url(${require(langEng ? './assets/categorias/en/7.png' : './assets/categorias/7.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                     setShowDrinks(true)
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                                </div>
                                
                                <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: 62,
                                    position: 'relative',
                                    cursor: 'pointer',
                                     backgroundImage: `url(${require(langEng ? './assets/categorias/8en.png' : './assets/categorias/8.png')})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    opacity: 1,
                                }}
                                onClick={() => {
                                     setShowListProduct(true);
                                         setdishs(desserts);
                                }}
                            >
                                <p
                                    style={{
                                        color: '#c40722',
                                        fontSize: 20,
                                    
                                        letterSpacing: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Noodle',
                                        textTransform: 'uppercase',
                                        margin: 0,
                                        maxWidth: '80%',
                                    }}
                                >
                                    
                                </p>
                            </div>
                        </div>
                    </div>

                    
                </div>
               
            </div>

           

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}

                {showLunchSpecial && <LunchSpecial setShowHappy={setShowLunchSpecial} />}
                
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
                {showPollo && <Pollo setShowHappy={setshowPollo} />}  
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
             {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}
            </div>
    );
}

export default Index;